import { createContext, useContext } from 'react';
import type { Context } from 'react';

export type Locales = {
  [key: string]: string | Locales;
};

export const translation = (locales: Locales | undefined, path: string): string => {
  const chunks = path.split('.');

  const result = chunks.reduce(
    (obj: Locales | string | undefined, key) => (typeof obj === 'object' ? obj[key] : undefined),
    locales
  );

  return typeof result === 'string' ? result : path;
};

const createLocalesContext = (): {
  LocalesContext: Context<Locales>;
  useLocales: () => (path: string) => string;
  useAllLocales: () => Locales;
} => {
  const LocalesContext = createContext<Locales>({});

  const useLocales = (): ((path: string) => string) => {
    const locales = useContext<Locales>(LocalesContext);

    return (path: string) => translation(locales, path);
  };

  const useAllLocales = (): Locales => useContext<Locales>(LocalesContext);

  return { LocalesContext, useLocales, useAllLocales };
};

export default createLocalesContext;
